var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 60,
    transform: "matrix(-1 0 0 1 60 60)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 60C1.875 27.8906 27.8906 1.875 60 1.875C92.1094 1.875 118.125 27.8906 118.125 60C118.125 92.1094 92.1094 118.125 60 118.125C27.8906 118.125 1.875 92.1094 1.875 60ZM106.875 60C106.875 34.2188 86.0156 13.125 60 13.125C34.2188 13.125 13.125 34.2188 13.125 60C13.125 86.0156 34.2188 106.875 60 106.875C86.0156 106.875 106.875 86.0156 106.875 60ZM81.7969 58.125C82.9688 59.2969 82.9688 60.9375 81.7969 62.1094L52.9688 90.9375C51.7969 91.875 50.1562 91.875 48.9844 90.9375L43.8281 85.5469C42.6562 84.375 42.6562 82.7344 43.8281 81.5625L65.1562 60L43.8281 38.6719C42.6562 37.5 42.6562 35.625 43.8281 34.6875L48.9844 29.2969C50.1562 28.125 51.7969 28.125 52.9688 29.2969L81.7969 58.125Z",
    fill: "#CFD7EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarArrowRight);
export default __webpack_public_path__ + "static/media/sidebar-arrow-right.326d4d33c0637435361e2a24c1e49ef1.svg";
export { ForwardRef as ReactComponent };